import axios from "axios";
import { useState } from "react";
import './Contact.css';

import {
  FaBriefcase,
  FaCommentDots,
  FaEnvelope,
  FaPhone,
  FaUser
} from "react-icons/fa";

function Contact() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    service: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const response = await axios.post(
        "https://script.google.com/macros/s/AKfycbxdAVUY20zINN32q9aq4n-SUACwLSiSSokQ1xb-Vic7VxiFAOr1tPBPOv7HI-8W-F8/exec",
        form,
        {
          headers: {
            "Content-Type": "text/plain;charset=utf-8"
          }
        }
      );

      console.log(response.data);

      alert("Thank you! Your enquiry has been submitted successfully.");

      setForm({
        name: "",
        email: "",
        mobile: "",
        service: "",
        message: ""
      });

    } catch (error) {

      console.error("Error submitting enquiry:", error);

      alert(
        "Sorry! Your enquiry could not be submitted. Please try again."
      );

    } finally {

      setLoading(false);

    }
  };

  return (

    <section id="contact" className="section contact">

      <div className="section-title">

        <p>GET IN TOUCH</p>

        <h2>Contact Us</h2>

      </div>

      <div className="contact-container">

        {/* LEFT SIDE */}

        <div className="contact-info">

          <h3>Let's Discuss Your Requirement</h3>

          <p>
            Contact us for software development,
            industrial automation, commissioning,
            technical support or training.
          </p>

          <div className="contact-item">
            📞 +91 899 908 6663
          </div>

          <div className="contact-item">
            📧 info@nasonstechs.com
          </div>

          <div className="contact-item">
            📧 hr@nasonstechs.com
          </div>

          <div className="contact-item">
            📍 Pune, Maharashtra, India
          </div>

        </div>


        {/* RIGHT SIDE FORM */}

        <form onSubmit={handleSubmit}>

          {/* NAME */}

          <div className="input-group">

            <FaUser className="input-icon" />

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
            />

          </div>


          {/* EMAIL */}

          <div className="input-group">

            <FaEnvelope className="input-icon" />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={form.email}
              onChange={handleChange}
              required
            />

          </div>


          {/* MOBILE */}

          <div className="input-group">

            <FaPhone className="input-icon" />

            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={form.mobile}
              onChange={handleChange}
              required
            />

          </div>


          {/* SERVICE */}

          <div className="input-group">

            <FaBriefcase className="input-icon" />

            <select
              name="service"
              value={form.service}
              onChange={handleChange}
              required
            >

              <option value="">
                Select Requirement
              </option>

              <option value="Software Development">
                Software Development
              </option>

              <option value="Web Development">
                Web Development
              </option>

              <option value="Java Full Stack">
                Java Full Stack
              </option>

              <option value="MERN Stack">
                MERN Stack
              </option>

              <option value="Python Development">
                Python Development
              </option>

              <option value="PLC Programming">
                PLC Programming
              </option>

              <option value="SCADA">
                SCADA
              </option>

              <option value="TIA Portal">
                TIA Portal
              </option>

              <option value="Commissioning">
                Commissioning
              </option>

              <option value="Technical Support">
                Technical Support
              </option>

              <option value="Training">
                Training
              </option>

              <option value="Consultancy">
                Consultancy
              </option>

            </select>

          </div>


          {/* MESSAGE */}

          <div className="input-group textarea-group">

            <FaCommentDots className="input-icon message-icon" />

            <textarea
              name="message"
              placeholder="Describe your requirement"
              value={form.message}
              onChange={handleChange}
              required
            />

          </div>


          {/* BUTTON */}

          <button
            type="submit"
            className="btn primary"
            disabled={loading}
          >

            {loading ? "Submitting..." : "Submit Enquiry"}

          </button>

        </form>

      </div>

    </section>

  );
}

export default Contact;